import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import { makeStyles } from 'tss-react/mui';
import useHubTranslation from '@/utils/i18n/useHubTranslation';

const useStyles = makeStyles()((theme) => ({
  main: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
  },
  title: {
    fontSize: '3em',
    fontWeight: 600,
  },
  code: {
    fontSize: '5em',
    color: theme.palette.primary.main,
    margin: '-1rem 0',
    fontWeight: 600,
  },
  message: {
    fontSize: '2em',
  },
}));

const ErrorScreen = (props) => {
  const { translateHubUi } = useHubTranslation();
  const { title, code, message, fontSize, goBack, refresh } = props;
  const router = useRouter();
  const { classes } = useStyles();

  const handleRefresh = () => {
    !!refresh && refresh();
    goBack ? router.back() : router.push('/hub');
  };

  return (
    <div className={classes.main} style={{ fontSize: fontSize || '1rem' }}>
      {code !== false && (
        <div className={classes.code}>
          {code || translateHubUi('common.errorScreen.defaultCode', '500')}
        </div>
      )}
      {title !== false && (
        <div className={classes.title}>
          {title || translateHubUi('common.errorScreen.defaultTitle', 'Oops!')}
        </div>
      )}
      <div className={classes.message}>
        {message ||
          translateHubUi(
            'common.errorScreen.defaultMessage',
            'An unexpected error has occurred'
          )}
      </div>
      <br />
      <br />
      {goBack !== false && (
        <Button
          variant='contained'
          color='primary'
          size='large'
          onClick={handleRefresh}
        >
          {translateHubUi('common.errorScreen.goBack', 'Go back')}
        </Button>
      )}
    </div>
  );
};

export default ErrorScreen;
